import $http from '@vue-util/http';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';

/**
 * Performs a GET request to the specified URL.
 * If the URL is an array, it performs multiple GET requests and combines the results.
 */
export function get<T = unknown>(url: string | string[], data?: object): Promise<T> {
  console.log(`Calling GET: ${url}`);

  if (Array.isArray(url)) {
    return Promise.all(url.map((u) => $http.get(u, data).then((res: AxiosResponse<T>) => res.data))).then((res) =>
      res.reduce((acc, cur) => Object.assign(acc, cur), {} as T),
    );
  }

  return $http.get(url, data).then((res: AxiosResponse<T>) => res.data);
}

/**
 * Performs a POST request to the specified URL.
 */
export function post<T = unknown>(url: string, data: object, config?: AxiosRequestConfig): Promise<T> {
  console.log(`Calling POST: ${url}`);
  return $http.post(url, data, config).then((res: AxiosResponse<T>) => res.data);
}

/**
 * Performs a DELETE request to the specified URL.
 */
export function deleteApi<T = unknown>(url: string, config?: AxiosRequestConfig): Promise<T> {
  console.log(`Calling DELETE: ${url}`);
  return $http.delete(url, config).then((res: AxiosResponse<T>) => res.data);
}
